<script setup>
import Pagination from '@/Components/Pagination.vue'
import ProjectCard from '@/Components/ProjectCard.vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import { index as projectsIndex } from '@/actions/App/Http/Controllers/ProjectController'

defineProps({
    projects: {
        type: Object,
        required: true,
    },
})
</script>

<template>
    <AppLayout
        meta_title="Realizace sádrokartonu, izolace a stěrek - Olomoucký kraj"
        meta_description="Prohlédněte si naše realizace sádrokartonu, foukané izolace a betonových stěrek v Olomouckém kraji. Inspirujte se a neváhejte nás kontaktovat."
        :meta_canonical="projectsIndex.url()"
    >
        <template #content>
            <section class="section-width mt-14 space-y-10 lg:space-y-32">
                <div class="mt-10 grid">
                    <div class="text-right">{{ projects.meta.total }} položek</div>

                    <div class="mt-3 grid grid-cols-1 gap-2 xl:grid-cols-3">
                        <div
                            class="flex flex-col justify-between space-y-4 rounded-4xl border border-gray-200 bg-gray-100 p-2 shadow shadow-gray-100"
                            v-for="project in projects.data"
                            :key="project.id"
                        >
                            <ProjectCard :project="project" />
                        </div>
                    </div>
                </div>

                <div class="my-5">
                    <Pagination :meta="projects.meta" />
                </div>
            </section>
        </template>
    </AppLayout>
</template>
